export default __webpack_public_path__ + "static/media/tip_calculator.8bc66ed8.png";